import { APPTYPE_UPDATE } from '../constants/appType'

export const updateAppType = (appType) => {
    return dispatch => {
        dispatch({
            type: APPTYPE_UPDATE,
            payload: appType
        });
    };
};